var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeFacetsForQuery } from '../../lib/facet';
import { makeAndFiltersForQuery, makeNegativeFilterForQuery, makeOrFiltersForQuery } from '../../lib/filter';
import { stringifyParams } from '../../lib/utils';
export const transformGetProviderByIdInputForApi = (input) => {
    const params = {};
    const { id: _id, slots_facet, slots_filter } = input, inputMinusFacetFilter = __rest(input, ["id", "slots_facet", "slots_filter"]);
    if (slots_filter === null || slots_filter === void 0 ? void 0 : slots_filter.and) {
        params.slots_filter = makeAndFiltersForQuery(slots_filter.and);
    }
    if (slots_filter === null || slots_filter === void 0 ? void 0 : slots_filter.or) {
        params['_slots_filter'] = makeOrFiltersForQuery(slots_filter.or);
    }
    if (slots_filter === null || slots_filter === void 0 ? void 0 : slots_filter.not) {
        params['-slots_filter'] = makeNegativeFilterForQuery(slots_filter.not);
    }
    if (slots_facet) {
        params.slots_facet = makeFacetsForQuery(slots_facet);
    }
    return Object.assign(Object.assign({}, params), inputMinusFacetFilter);
};
/**
 * getProviderById query function.
 *
 * @param client the internal client instance
 * @param config the internal client configuration object
 * @param input input parameters for paring down the search results
 *
 * @category Query Functions - getProviderById
 * @category Query Functions
 */
export const getProviderById = (client, config, input) => {
    const { customerCode } = config;
    const { id } = input;
    return client.get(`/${customerCode}/providers/${id}`, {
        params: input,
        paramsSerializer: (params) => {
            const transformedParams = transformGetProviderByIdInputForApi(params);
            return stringifyParams(transformedParams);
        }
    });
};
//# sourceMappingURL=getProviderById.js.map